/**
 * This is the shared configuration for the app.
 *
 * All dependent scripts should include this file if they rely on configured values.
 */
import extend from "deep-extend";
//import freeze from "deep-freeze-strict";
import { AppConfig } from "./types";
import defaultConfig from "./config/index";
import { MaisonIdentifier, maisons } from "./types";
import { get } from "./utils/helpers";

const isBrand = (name: any): name is MaisonIdentifier => maisons.includes(name);

export function getBrandId(): string {
  let brandId;
  if (process.env.REACT_APP_BRAND_ID) {
    brandId = `${process.env.REACT_APP_BRAND_ID}`;
  } else {
    const { pathname } = document.location;
    brandId = pathname
      .split("/")
      .filter(name => Boolean && isBrand(name))
      .pop();
  }
  return brandId || "lvmh";
}

export function updateConfig(newConfig: any) {
  appConfig = extend(appConfig, newConfig);
}

/*
 * retrieves value from config
 * supports config by zones (config.zones[].config)
 */

export function getConfigValue(zone: string, key: string, defaultValue?: any) {
  const zoneConfigValue =
    zone && get(appConfig, `zones[${zone}].config.${key}`);
  if (zone && zoneConfigValue !== undefined) {
    return zoneConfigValue;
  }
  return get(appConfig, key, defaultValue);
}

// I've had to make this more static due to issues with webpack
// importing in tests, stories and snapshots if I try to do something
// like `require("./config/${getBrandId()}/index")`
function getBrandConfig(): object {
  switch (getBrandId()) {
    case "celine":
      return require("./config/celine/index").default;

    case "rimowa":
      return require("./config/rimowa/index").default;

    case "guerlain":
      return require("./config/guerlain/index").default;

    case "guerlain-fr":
      return require("./config/guerlain-fr/index").default;

    case "fred":
      return require("./config/fred/index").default;
    case "tiffany":
      return require("./config/tiffany/index").default;
    case "tiffany-jp":
      return require("./config/tiffany-jp/index").default;

    default:
      return require("./config/lvmh/index").default;
  }
}

const brandConfig = getBrandConfig();
var appConfig: AppConfig = extend({}, defaultConfig, brandConfig);

export default appConfig;
